import { useEffect, useState } from "react";
import Scrollspy from "react-scrollspy";
import { useTranslation } from "react-i18next";

const Header = (props) => {
  const { t } = useTranslation("clientSite"); // expects keys under "header.*"
  const [click, setClick] = useState(false);
  const [navbar, setNavbar] = useState(false);

  const handleClick = () => setClick((v) => !v);

  useEffect(() => {
    const changeBackground = () => setNavbar(window.scrollY >= 71);
    changeBackground(); // set initial state
    window.addEventListener("scroll", changeBackground);
    return () => window.removeEventListener("scroll", changeBackground);
  }, []);

  return (
    <>
      <header className={navbar ? "main-header fixed-header" : "main-header"}>
        <nav>
          <div className="header-opacity">
            {/* Mobile menu toggle */}
            <button
              className="navbar-toggler"
              type="button"
              onClick={handleClick}
              aria-label={
                click ? t("header.aria.closeMenu") : t("header.aria.openMenu")
              }
              aria-expanded={click ? "true" : "false"}
              aria-controls="menuHandler"
            >
              <div
                id="menuHamburger"
                className={click ? "hamburgerm active" : "hamburgerm"}
              >
                <span></span>
                <span></span>
                <span></span>
              </div>
            </button>

            {/* Logo */}
            {props.site?.logoFilename ? (
              <img
                className="navbar-style"
                src={
                  process.env.REACT_APP_API_SERVICE_BASE_URL +
                  "image/" +
                  "SiteLogoImages/" +
                  props.site.logoFilename
                }
                alt={t("header.labels.logoAlt", {
                  shop: props.site?.shopName || props.site?.name || "",
                })}
              />
            ) : (
              <div />
            )}

            {/* Slide-out menu */}
            <div
              id="menuHandler"
              className={
                click
                  ? "small-menu justify-content-end active"
                  : "small-menu justify-content-end"
              }
            >
              <div style={{ display: "flex", justifyContent: "end" }}>
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={handleClick}
                  style={{ marginRight: "0.2rem", marginTop: "0.5rem" }}
                  aria-label={t("header.aria.closeMenu")}
                  aria-controls="menuHandler"
                >
                  <div id="menuHamburger" className={"hamburgerm active"}>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </button>
              </div>

              <Scrollspy
                className="an navbar-top ml-auto"
                currentClassName="current"
                offset={-150}
              >
                {/* Menu title */}
                <p
                  className="powered-by-message"
                  style={{ marginBottom: "2rem" }}
                >
                  {t("header.menu")}
                </p>

                {/* Links */}
                <li>
                  <a className="nav-link" href="#home" onClick={handleClick}>
                    <span>{t("header.nav.home")}</span>
                  </a>
                </li>

                {props.site?.aboutUsPageEnabled ? (
                  <li>
                    <a className="nav-link" href="#about" onClick={handleClick}>
                      <span>{t("header.nav.about")}</span>
                    </a>
                  </li>
                ) : null}

                {props.site?.servicePageEnabled ? (
                  <li>
                    <a
                      className="nav-link"
                      href="#services"
                      onClick={handleClick}
                    >
                      <span>{t("header.nav.services")}</span>
                    </a>
                  </li>
                ) : null}

                {props.site?.staffPageEnabled ? (
                  <li>
                    <a className="nav-link" href="#staff" onClick={handleClick}>
                      <span>{t("header.nav.team")}</span>
                    </a>
                  </li>
                ) : null}

                {/* Footer message */}
                <p
                  className="powered-by-message"
                  style={{ position: "absolute", bottom: "40px" }}
                >
                  {t("header.messages.poweredBy", { brand: process.env.REACT_APP_COMPANY_NAME })}
                </p>
              </Scrollspy>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;
